import { WithNativeHTMLProps } from "@kalyzee/kast-web-sdk/web-components";
import { KalyzeeLoader } from "@kalyzee/kalyzee-ui";
import React, { useMemo } from "react";
import { AnimatedBackground } from "./AnimatedBackground";
import styles from "./LoadingView.module.css";

export interface LoadingViewProps extends WithNativeHTMLProps<HTMLDivElement> {
  message?: string;
  fullscreen?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export interface LoadingViewRef {}

export const LoadingView = React.forwardRef(({ message = "Chargement en cours", fullscreen, className, style, ...nativeProps }: LoadingViewProps) => {
  const outerClass = useMemo(() => {
    const classes = [styles.outer];
    if (fullscreen) classes.push(styles.fullscreen);
    if (className) classes.push(className);
    return classes.join(" ");
  }, [className, fullscreen]);

  return (
    <div className={outerClass} style={style} {...nativeProps}>
      <AnimatedBackground contentClassName={styles.container}>
        <KalyzeeLoader />
        {message !== undefined && (
          <span className={styles.message}>{message}</span>
        )}
      </AnimatedBackground>
    </div>
  );
});
